import { ComponentBootstrap } from '@demant/wdh-react-bootstrap';
import BlogRelatedApp from './react-blog-related';
var ReactBlogRelated = new ComponentBootstrap('related-blogs');
ReactBlogRelated.reactApp = BlogRelatedApp;
ReactBlogRelated.run();